import I18n from "i18n-js";
import {Button} from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';

export interface FacebookShareProps {
  url: string;
  text?: string;
}
export default function FacebookShare({url, text}: FacebookShareProps) {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  if (!text) {
    text = I18n.t("SocialShare.facebook.defaultText");
  }

  return (
    <Button
      startIcon={<FacebookIcon />}
      fullWidth={false}
      href={shareUrl}
      target="_blank"
      sx={{
        color: "#FFFFFF",
        backgroundColor: "#3b5998",
        lineHeight: "1",
        width: "auto",
        marginRight: "5px",
        ":hover": {
          backgroundColor: "#213A6F",
        }
      }}
    >
      {text}
    </Button>
  );
}